<template>
    <div>
        <!-- 頭部 -->
        <headers :background-bg="false" :is-home-page="true"></headers>

        <div :style="{minHeight: contentMinHeight}">
            <!-- 全景 -->
            <div class="pano-work-box" id="pano">
                <div style="position:absolute;width:100%;height:100%;z-index:1;background:rgba(0,0,0,0.3);">
                    <div class="text-contents">
                        <div class="img-con">
                            <img src="/ssr/static/images/portal/t.png"/>
                        </div>
                        <div class="text-con">
                            <h1>歡迎使用 全景100</h1>
                            <p>
                                3分鐘打造自己的VR智慧工地，助力裝修建材企業成交翻倍<br>
                                會玩手機就會用的VR採集系統
                            </p>
                            <a href="tel:02862328167">
                                <a-button type="primary" class="ant-btns" size="large">
                                    全國統一咨詢熱線：028-6232 8167
                                </a-button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- vr智慧工地 -->
            <div class="modular-wrap">
                <div class="point-box" id="content1"></div>
                <div class="titles">
                    <h1>VR智慧工地</h1>
                    <h5>智慧時代，快一步搶佔先機</h5>
                </div>
                <div class="contents">
                    <div class="model-img-text">
                        <a-row>
                            <a-col :xs="24" :md="12">
                                <div class="img-con">
                                    <img src="/ssr/static/images/portal/t1.png"/>
                                </div>
                            </a-col>
                            <a-col :xs="24" :md="12">
                                <div class="text-con">
                                    <h1><span>VR水電、樣板間、裝修效果</span>一鍵採集</h1>
                                    <p>
                                        裝修施工節點一鍵拍攝，實時分享、永久存檔，智慧裝修快人一步；<br/>
                                        適用於樣板間、房產中介極速拍攝，極刻分享；<br/>
                                        VR裝修效果圖拍攝，不同風格隨意切換；<br/>
                                        VR公寓拍攝、民宿、酒店拍攝，360度無死角全景呈現；<br/>
                                        持續關注，更多功能持續上線。
                                    </p>
                                </div>
                            </a-col>
                        </a-row>
                    </div>
                    <div class="model-img-text">
                        <a-row>
                            <a-col :xs="24" :md="12">
                                <div class="text-con">
                                    <h1>企業/員工/業主<span>數據共享</span>，權限配置</h1>
                                    <p>
                                        3分鐘智慧採集數據，機內快速拼接，APP實時上傳至雲端系統，自助管理，編輯便利，數據永不丟失。
                                    </p>
                                </div>
                            </a-col>
                            <a-col :xs="24" :md="12">
                                <div class="img-con"><img src="/ssr/static/images/portal/t2.png"/> </div>
                            </a-col>
                        </a-row>
                    </div>
                </div>
            </div>
            <!-- 手機小程序等 -->
            <div class="pull-screen-wrap">
                <div class="modular-wrap">
                    <div class="point-box" id="content2"></div>
                    <div class="titles" style="margin-bottom: 40px">
                        <h1>企業小程序/公眾號</h1>
                        <h5>兼容PC、手機、小程序，各種瀏覽器</h5>
                    </div>
                    <div class="contents padding-b-80">
                        <div class="wap-pc-box">
                            <a-row>
                                <a-col :xl="8" :lg="8" :md="7" :sm="12" :xs="24">
                                    <ul class="text-box text-right">
                                        <li>
                                            <div class="icon-box"><img src="/ssr/static/images/portal/icon1.png"/> </div>
                                            <div class="texts">
                                                <h4>門店展示</h4>
                                                <h5>門店形象，風格隨時可變</h5>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon-box"><img src="/ssr/static/images/portal/icon2.png"/> </div>
                                            <div class="texts">
                                                <h4>工地地圖</h4>
                                                <h5>企業工地在區域地圖顯示，讓客戶知道你的所有房源</h5>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon-box"><img src="/ssr/static/images/portal/icon3.png"/> </div>
                                            <div class="texts">
                                                <h4>團隊名片</h4>
                                                <h5>團隊形象牆，讓客戶知道你的專業</h5>
                                            </div>
                                        </li>
                                    </ul>
                                </a-col>
                                <a-col :xl="8" :lg="8" :md="10" :sm="0" :xs="0">
                                    <div class="img-box"><img src="/ssr/static/images/portal/ces.png"/> </div>
                                </a-col>
                                <a-col :xl="8" :lg="8" :md="7" :sm="12" :xs="24">
                                    <ul class="text-box">
                                        <li>
                                            <div class="icon-box"><img src="/ssr/static/images/portal/icon4.png"/> </div>
                                            <div class="texts">
                                                <h4>VR進度/工藝節點</h4>
                                                <h5>全景每一步進度，便利性取得客戶信賴</h5>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon-box"><img src="/ssr/static/images/portal/icon5.png"/> </div>
                                            <div class="texts">
                                                <h4>在線咨詢、裂變營銷</h4>
                                                <h5>語音、視頻實時聯通解析疑惑，分享信息可獲收益</h5>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon-box"><img src="/ssr/static/images/portal/icon6.png"/> </div>
                                            <div class="texts">
                                                <h4>訪問統計、咨詢統計</h4>
                                                <h5>客戶登錄認證信息，再單個全景停留的時間進行訪問統計，並可以線上跟蹤客戶</h5>
                                            </div>
                                        </li>
                                    </ul>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 技術支持 -->
            <div class="modular-wrap">
                <div class="point-box" id="content3"></div>
                <div class="titles">
                    <h1>實力技術支持</h1>
                    <h5>2016年從事VR裝修系統研發以來，獲得十餘項核心技術產權</h5>
                </div>
                <div class="contents">
                    <div class="technical-support-box">
                        <swiper ref="mySwiper" class="swiper" :options="swiperOption" >
                            <swiper-slide v-for="(item,index) in bannerList" :key="index">
                                <img :src="item"/>
                            </swiper-slide>
                            <div class="swiper-button-prev" slot="button-prev">
                                <a-icon type="arrow-left" />
                            </div>
                            <div class="swiper-button-next" slot="button-next">
                                <a-icon type="arrow-right" />
                            </div>
                        </swiper>
                    </div>
                </div>
            </div>
            <!-- 聯繫我們 -->
            <div class="contact-us-box">
                <div class="point-box" id="content4"></div>
                <a-row>
                    <a-col :xs="0" :sm="0" :md="12">
                        <div class="img-con">
                            <img src="/ssr/static/images/portal/phone.png"/>
                        </div>
                    </a-col>
                    <a-col :xs="24" :sm="24" :md="12">
                        <div class="box-content">
                            <h1>聯繫我們</h1>
                            <h5>平台使用、咨詢合作請聯繫7*11小時在線客服</h5>
                            <h2>137-6040-7022</h2>
                            <a href="tel:13760407022" class="ant-btns">立即咨詢</a>
                        </div>
                    </a-col>
                </a-row>
            </div>
        </div>
        <!-- 底部 -->
        <footers></footers>
    </div>
</template>

<script>
    import headers from "./components/header";
    import footers from "./components/footer";
    import {Swiper, SwiperSlide} from "vue-awesome-swiper";
    import "swiper/swiper-bundle.css";
    import Swiper2, {Navigation,Pagination} from "swiper";
    import { getWorkDetail } from "@/api/work";
    import { baseUrl } from "@/config";
    import wx from "weixin-js-sdk";
    import { getJsSign, getOauthRedirect } from "@/api/wechat";
    import { mapState } from "vuex";

    Swiper2.use([Navigation,Pagination])
    export default {
        data() {
            return {
                newWork: {
                    base: {},
                    ads: {},
                    sets: {},
                    menus: [],
                    guide: [],
                    sandtable: [],
                },
                contentMinHeight:'',
                bannerList:[
                    '/ssr/static/qwj/images/1.jpg',
                    '/ssr/static/qwj/images/2.jpg',
                    '/ssr/static/qwj/images/3.jpg',
                    '/ssr/static/qwj/images/4.jpg',
                    '/ssr/static/qwj/images/5.jpg',
                    '/ssr/static/qwj/images/6.jpg',
                    '/ssr/static/qwj/images/7.jpg',
                    '/ssr/static/qwj/images/1.jpg',
                    '/ssr/static/qwj/images/2.jpg',
                    '/ssr/static/qwj/images/3.jpg',
                    '/ssr/static/qwj/images/4.jpg',
                    '/ssr/static/qwj/images/5.jpg',
                    '/ssr/static/qwj/images/6.jpg',
                    '/ssr/static/qwj/images/7.jpg',
                ],
                swiperOption: {
                    observer: true,
                    observeParents: true,
                    centeredSlides: false,
                    autoplay: {
                        delay: 1500,
                        disableOnInteraction: false
                    },
                    breakpoints: {
                        320: {  //當屏幕寬度大於等於320
                            slidesPerView: 3,
                            spaceBetween: 20
                        },
                        768: {  //當屏幕寬度大於等於768
                            slidesPerView: 6,
                            spaceBetween: 20
                        },
                        992:{
                            slidesPerView: 7,
                            spaceBetween: 30
                        }
                    },
                    // loop: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            };
        },
        components: {
            headers,
            footers,
            Swiper,
            SwiperSlide
        },
        created(){
            //生產環境不應該出現單頁應用的首頁，刷新切換
            if (process.env.NODE_ENV === "production") {
                window.location.href = "/";
            }
        },
        mounted() {
            this.contentMinHeight = setHeight();
            this.workDetail();
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper;
            },
            ...mapState({
                siteInfo: (state) => state.siteConfig.siteInfo,
            }),
        },
        methods: {
            workDetail() {
                let id = 13;
                getWorkDetail({ id })
                .then((res) => {
                    this.workInit(res);
                })
                .catch(() => {});
            },
            workInit(res) {
                if (res.code === 1) {
                    // 判斷用戶帳號是否過期
                    if (res.data.base && res.data.base.expire_status) {
                    this.isOverdue = true;
                    }
                    this.newWork = res.data;
                    this.wxInit();

                    initVrshowVue(this);
                    setWork(this.newWork);
                    setMode("tour");
                    setTourXml(`/api/tourXml?id=${this.newWork.base.id}`);

                    let krsettings = {
                    "events[skin_events].onpreviewcomplete": "js(tourHideLoading());", //隱藏加載中狀態
                    "events[init_view_event].onclick": "js(tourHideThumbs());", //點擊漫遊隱藏縮略圖
                    "events[skin_events].onnewscene": "js(tourUpdateCurrentScene());", //進入場景時更新當前場景值給縮略圖組件
                    "autorotate.enabled": true,

                    //"autorotate.horizon'] = work.sets.keepview=='1' ? "off" : "0.0";
                    };
                    this.krpanoObj = launchKrpano(krsettings,"/ssr/static/tour/tour.swf");

                    this.group_List = this.getGroupList(
                    this.newWork.scene_group.groups,
                    this.newWork.scenes
                    );
                    let scenesCount = Object.keys(this.newWork.scenes).length;
                    if(scenesCount>1){
                    this.sceneShow = true;
                    }else{
                    this.sceneShow = false;
                    }
                    console.log("場景初始化",this.group_List);
                    this.$store.dispatch("setVRBase", this.newWork).then(() => {
                    this.getFirstSenceFromAll();
                    this.handleSandboxShow();
                    });
                }
                this.$message.destroy();
            },
            wxInit() {
                let self = this;
                getJsSign({ url: location.href.split("#")[0] }).then((res) => {
                    wx.config({ ...res.data });
                    wx.ready(function () {
                    //需在用戶可能點擊分享按鈕前就先調用
                    wx.updateAppMessageShareData({
                        title: self.siteInfo.sitename, // 分享標題
                        desc: self.siteInfo.description, // 分享描述
                        link: location.href.split("#")[0], // 分享鏈接，該鏈接域名或路徑必須與當前頁面對應的公眾號JS安全域名一致
                        imgUrl: "https://static.qwj.symboot.com/icon-100.png", // 分享圖標
                        success: function () {
                        // 設置成功
                        },
                    });
                    wx.updateTimelineShareData({
                        title: self.siteInfo.sitename, // 分享標題
                        link: location.href.split("#")[0], // 分享鏈接，該鏈接域名或路徑必須與當前頁面對應的公眾號JS安全域名一致
                        imgUrl: "https://static.qwj.symboot.com/icon-100.png", // 分享圖標
                        success: function () {
                        // 設置成功
                        },
                    });
                    });
                });
            },
        }
    };
</script>
<style lang="less" scoped>
    *{
        font-family: Noto Sans SC,PingFang SC,Avenir Next,ST Heiti,Hiragino Sans GB,Microsoft YaHei,sans-serif;
    }
    ul, li {
        margin: 0;
        padding: 0;
    }
    .pano-work-box{
        height: 700px;
        background-color: #333;
        position: relative;
        .text-contents{
            position: absolute;
            left: 50%;
            margin-left: -550px;
            width: 1100px;
            height: 100%;
            padding: 150px 0 0 630px;
            .img-con{
                position: absolute;
                left: 0;
                width:600px;
                /*height:400px;*/
                /*background:red;*/
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    width: 100%;
                }
            }
            .text-con{
                color: #ffffff;
                margin-top: 50px;
                h1{
                    font-size:52px;
                    font-weight:bold;
                    color: #ffffff;
                    margin-bottom: 5px;
                }
                p{
                    font-size:24px;
                    line-height: 160%;
                }
                .ant-btns{
                    height: 40px;
                    font-size: 15px;
                }
            }
        }
    }
    @media (max-width: 1200px) {
        .pano-work-box{
            height: 500px;
            .text-contents{
                padding: 84px 0 0 480px;
                margin-left: -425px;
                width: 850px;
                .img-con{
                    left: 0;
                    width:450px;
                }
                .text-con{
                    color: #ffffff;
                    margin-top: 50px;
                    h1{
                        font-size:40px;
                    }
                    p{
                        font-size:20px;
                    }
                }
            }
        }
    }
    @media (max-width: 992px) {
        .pano-work-box{
            height: 450px;
            .text-contents{
                padding: 96px 0 0 430px;
                margin-left: -350px;
                width: 700px;
                .img-con{
                    left: 0;
                    width:400px;
                }
                .text-con{
                    color: #ffffff;
                    margin-top: 30px;
                    h1{
                        font-size:32px;
                    }
                    p{
                        font-size:17px;
                    }
                }
            }
        }
    }
    @media (max-width: 767px) {
        .pano-work-box{
            height: 300px;
            .text-contents{
                margin-left: auto;
                left: auto;
                width: 100%;
                max-width: none;
                padding: 90px 20px 0 20px;
                .img-con{
                    display: none;
                }
                .text-con{
                    margin-top: 0;
                    text-align: center;
                    h1{
                        font-size:28px;
                    }
                    p{
                        font-size:14px;
                    }
                    .ant-btns{
                        height: 36px;
                        font-size: 12px;
                    }
                }
            }
        }
    }

    .pull-screen-wrap{
        background-color: #f5f8ff;
        background-image: url("/ssr/static/images/portal/bg.png");
        background-position: center;
        background-size: cover;
    }
    .point-box{
        position: absolute;
        top: -58px;
    }
    .padding-b-80{padding-bottom: 80px}
    .modular-wrap{
        max-width: 1200px;
        margin: 0 auto;
        padding: 60px 0 20px 0;
        position: relative;
        .titles{
            text-align: center;
            margin-bottom: 80px;
            h1{
                font-size: 36px;
                color: #333;
                margin-bottom: 0;
            }
            h5{
                font-size: 20px;
                color: #999;
            }
        }
    }
    .model-img-text{
        margin-bottom: 60px;
        .img-con{
            img{
                max-width: 100%;
                width: 100%;
            }
        }
        .text-con{
            padding-top: 140px;
            h1{
                font-size: 28px;
                font-weight: 500;
                color: #333;
                margin-bottom: 4px;
                span{
                    color: #1890ff;
                }
            }
            p{
                font-size: 18px;
                color: #666;
                line-height: 160%;
                /*font-weight: lighter;*/
            }
        }
    }
    @media (max-width: 992px) {
        .modular-wrap{
            .titles{
                margin-bottom: 60px;
                h1{
                    font-size: 30px;
                }
                h5{
                    font-size: 18px;
                }
            }
        }
        .model-img-text{
            .text-con{
                padding-top: 140px;
                h1{
                    font-size: 24px;
                }
                p{
                    font-size: 16px;
                    /*font-weight: lighter;*/
                }
            }
        }
    }
    @media (max-width: 767px) {
        .modular-wrap{
            .titles{
                margin-bottom: 40px;
                h1{
                    font-size: 26px;
                }
                h5{
                    font-size: 16px;
                }
            }
        }
        .model-img-text{
            border-bottom: 1px solid #e8e8e8;
            &:last-child{
                border-bottom: 0;
            }
            margin-bottom: 40px;
            .text-con{
                padding: 20px;
                h1{
                    font-size: 20px;
                }
                p{
                    font-size: 14px;
                    /*font-weight: lighter;*/
                }
            }
        }
    }
    .img-box{
        padding: 0 60px;
        img{
            max-width: 100%;
            width: 100%;
            box-shadow: 2px 2px 6px 2px rgba(0,0,0,.04);
        }
    }
    .text-box{
        overflow: hidden;
        padding-top: 40px;
        &.text-right{
            li{
                padding-left: 0;
                padding-right: 80px;
                .icon-box{
                    left: auto;
                    right: 0;
                }
                .texts{
                    text-align: right;
                }
            }
        }
        li{
            margin: 20px 0;
            height: 120px;
            position: relative;
            padding-left: 80px;
            &:hover{
                cursor: pointer;
                .icon-box{
                    background-color: rgba(24,144,255,.5);
                }
                .texts{
                    h4{
                        color: #1890ff;
                    }
                }
            }
            .icon-box{
                position: absolute;
                top: 0;
                left: 0;
                width: 70px;
                height: 70px;
                line-height: 70px;
                text-align: center;
                border-radius: 50%;
                background-color: rgba(24,144,255,.3);
                transition: all .3s ease;
            }
            .texts{
                padding: 5px 0 0 0;
                h4{
                    font-size: 24px;
                    color: #333;
                    margin-bottom: 5px;
                }
                h5{
                    font-size: 16px;
                    color: #999;
                    line-height: 150%;
                }
            }
        }
    }
    @media (max-width: 1200px) {
        .text-box{
            padding-top: 0;
            &.text-right{
                li{
                    padding-left: 0;
                    padding-right: 70px;
                }
            }
            li{
                margin: 20px 0;
                height: 110px;
                padding-left: 70px;
                .icon-box{
                    width: 60px;
                    height: 60px;
                    line-height: 60px;
                    img{
                        max-width: 35px;
                    }
                }
                .texts{
                    padding: 0;
                    h4{
                        font-size: 22px;
                    }
                    h5{
                        font-size: 15px;
                    }
                }
            }
        }
    }
    @media (max-width: 767px) {
        .padding-b-80{padding-bottom: 40px}
        .text-box{
            padding: 0 20px;
            &.text-right{
                li{
                    padding-left: 70px;
                    padding-right: 0;
                    .icon-box{
                        left: 0;
                        right: auto;
                    }
                    .texts{
                        text-align: left;
                    }
                }
            }
            li{
                margin: 0 0 30px 0;
                height: auto;
                min-height: 60px;
                padding-left: 70px;
                .icon-box{
                    width: 60px;
                    height: 60px;
                    line-height: 60px;
                    img{
                        width: 40px;
                    }
                }
                .texts{
                    h4{
                        font-size: 18px;
                    }
                    h5{
                        font-size: 13px;
                    }
                }
            }
        }
    }
    .technical-support-box{
        margin-bottom: 80px;
        /*.swiper{
            padding: 10px 0;
        }*/
        .swiper-slide{
            /*height: 400px;*/
            background-color: #1890ff;
            cursor: pointer;
            /*border: 2px solid #ffffff;*/
            &:hover{
                /*box-shadow: 0 0 12px 3px rgba(0,0,0,.03);*/
                /*border: 2px solid #1890ff;*/
            }
            img{
                max-width: 100%;
            }
        }
        .swiper-button-prev, .swiper-button-next{
            width: 40px;
            height: 40px;
            margin-top: -20px;
            border-radius: 50%;
            background-color: rgba(0,0,0,.4);
            color: #ffffff;
            font-size: 18px;
            &:hover{
                background-color: rgba(0,0,0,.6);
            }
        }
        .swiper-button-prev:after, .swiper-button-next:after{
            display: none;
        }
    }
    @media (max-width: 767px) {
        .technical-support-box{
            padding: 0 20px;
        }
    }
    .contact-us-box{
        max-width: 1200px;
        margin: 0 auto;
        /*padding: 0 0 80px 0;*/
        padding: 40px 0;
        border-top: 1px solid #e8e8e8;
        position: relative;
        .img-con{
            text-align: right;
            padding-right: 30px;
        }
        .box-content{
            padding: 60px 0;
            h1{
                font-size: 36px;
                margin-bottom: 0;
                color: #333;
            }
            h5{
                font-size: 20px;
                color: #999;
                line-height: 160%;
            }
            h2{
                font-size: 40px;
                margin-bottom: 5px;
            }
            .ant-btns{
                display: inline-block;
                text-decoration: none;
                padding: 0 12px;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                background-color: #1890ff;
                color: #ffffff;
                border: 1px solid #1890ff;
                font-size: 15px;
                transition: all .3s ease;
                &:hover{
                    background-color: #40a9ff;
                    border: 1px solid #40a9ff;
                }
            }
        }
    }
    @media (max-width: 992px) {
        .contact-us-box{
            .box-content{
                h1{
                    font-size: 30px;
                }
                h5{
                    font-size: 18px;
                }
                h2{
                    font-size: 36px;
                }
            }
        }
    }
    @media (max-width: 767px) {
        .contact-us-box{
            /*padding: 40px 0;*/
            padding: 0;
            .box-content{
                padding: 40px 20px;
                h1{
                    font-size: 26px;
                }
                h5{
                    font-size: 16px;
                }
                h2{
                    font-size: 30px;
                }
                .ant-btns{
                    border-radius: 2px;
                    font-size: 14px;
                }
            }
        }
    }
</style>
